export const USERS_URLS = {
  INVITE_USER: 'users/invite',
  USERS: 'users',
  LINK_USER: 'users/link',
  GET_USER_PROFILE: 'users/profile',
  UPDATE_USER_ROLE: 'users/role',
  GET_ALL_USERS_LOOKUP_WITH_ROLE: 'users/usersWithRole',
  GET_USER_ASSOCIATED_ORDER_NO: (id: string) => `users/${id}/orders-count`,
  DELETE: (id: string) => `users/${id}`,
  ACCOUNT_INFO: 'users/AccountInfo',
  SEND_CHANGE_PASSWORD_EMAIL: 'users/send-change-password-email',
};
